import React, { useState, useRef, useCallback, useEffect, useMemo } from "react";
import "./SectionBrandingDesignNew.css";
import "../../../GalleryShared.css";

import naukri01         from "../../../../../Assets/Images/gallary/branding/naukri01.webp";
import naukri02         from "../../../../../Assets/Images/gallary/branding/naukri02.webp";
import naukri03         from "../../../../../Assets/Images/gallary/branding/naukri03.webp";
import naukri04         from "../../../../../Assets/Images/gallary/branding/naukri04.webp";
import Recoup01         from "../../../../../Assets/Images/gallary/branding/Recoup01.webp";
import Recoup02         from "../../../../../Assets/Images/gallary/branding/Recoup02.webp";
import Recoup03         from "../../../../../Assets/Images/gallary/branding/Recoup03.webp";
import Quench01           from "../../../../../Assets/Images/gallary/branding/bdquench01.webp";
import Quench02           from "../../../../../Assets/Images/gallary/branding/bdquench02.webp";
import Quench03           from "../../../../../Assets/Images/gallary/branding/bdquench03.webp";
import Quench04           from "../../../../../Assets/Images/gallary/branding/bdtraffic01.webp";
import Quench05           from "../../../../../Assets/Images/gallary/branding/bdpowertron01.webp";
import Quench06           from "../../../../../Assets/Images/gallary/branding/bdpowertron02.webp";
import yobyke1        from "../../../../../Assets/Images/gallary/branding/yobkes 1.webp";
import yobykeflyer        from "../../../../../Assets/Images/gallary/branding/flyer.webp";
import FloretFlyer02        from "../../../../../Assets/Images/gallary/branding/FloretFlyer (2).png";
import yobykecalender       from "../../../../../Assets/Images/gallary/branding/calender.webp";
import yobykehoarding       from "../../../../../Assets/Images/gallary/branding/hoarding.webp";
import yobykemain      from "../../../../../Assets/Images/gallary/branding/main Bannerjpg.webp";
import yobykenewspaper      from "../../../../../Assets/Images/gallary/branding/newspaper.webp";
import ETindoor      from "../../../../../Assets/Images/gallary/branding/ET Indoor.webp";
import Business_card       from "../../../../../Assets/Images/gallary/branding/Business card.webp";
import kbl01       from "../../../../../Assets/Images/gallary/branding/KBL1.webp";
import kbl02         from "../../../../../Assets/Images/gallary/branding/KBL2.webp";
import kbl03      from "../../../../../Assets/Images/gallary/branding/KBL3.webp";
import kbl04      from "../../../../../Assets/Images/gallary/branding/KBL4.webp";
import kbl05      from "../../../../../Assets/Images/gallary/branding/KBL5.webp";
import kbl06      from "../../../../../Assets/Images/gallary/branding/KBL6.webp";
import kbl07      from "../../../../../Assets/Images/gallary/branding/KBL7.webp";
import forbes01       from "../../../../../Assets/Images/gallary/branding/forbes01.webp";
import forbes02        from "../../../../../Assets/Images/gallary/branding/forbes02.webp";
import forbes03      from "../../../../../Assets/Images/gallary/branding/forbes03.webp";
import naukribrochure01      from "../../../../../Assets/Images/gallary/branding/naukribrochure01.webp";
import naukribrochure02      from "../../../../../Assets/Images/gallary/branding/naukribrochure02.webp";
import balaji01      from "../../../../../Assets/Images/gallary/branding/balaji01.webp";
import balaji02      from "../../../../../Assets/Images/gallary/branding/balaji02.webp";
import balaji03      from "../../../../../Assets/Images/gallary/branding/balaji03.webp";
import recoupbrochure01      from "../../../../../Assets/Images/gallary/branding/recoupbrochure01.webp";
import recoupbrochure02      from "../../../../../Assets/Images/gallary/branding/recoupbrochure02.webp";
import recoupbrochure03      from "../../../../../Assets/Images/gallary/branding/recoupbrochure03.webp";
import recoupbrochure04      from "../../../../../Assets/Images/gallary/branding/recoupbrochure04.webp";
import recoupbrochure05      from "../../../../../Assets/Images/gallary/branding/recoupbrochure05.webp";
import recoupbrochure06      from "../../../../../Assets/Images/gallary/branding/recoupbrochure06.webp";
import recoupbrochure07      from "../../../../../Assets/Images/gallary/branding/recoupbrochure07.webp";
import recoupbrochure08      from "../../../../../Assets/Images/gallary/branding/recoupbrochure08.webp";
import recoupbrochure09      from "../../../../../Assets/Images/gallary/branding/recoupbrochure09.webp";
import recoupbrochure10      from "../../../../../Assets/Images/gallary/branding/recoupbrochure10.webp";
import flyeryobykes      from "../../../../../Assets/Images/gallary/branding/flyeryobykes.webp";
import yoFlyer      from "../../../../../Assets/Images/gallary/branding/yoFlyer.webp";
import yohoarding_1      from "../../../../../Assets/Images/gallary/branding/yohoarding_1.webp";
import yoHording_02      from "../../../../../Assets/Images/gallary/branding/yoHording_02.webp";
import yoMango      from "../../../../../Assets/Images/gallary/branding/yoMango sticker box.webp";
import yonewspaper      from "../../../../../Assets/Images/gallary/branding/yonewspaper.webp";
import yonotepad      from "../../../../../Assets/Images/gallary/branding/yonotepad.webp";
import yopresentation_1      from "../../../../../Assets/Images/gallary/branding/yopresentation_1.webp";
import yopresentation_2      from "../../../../../Assets/Images/gallary/branding/yopresentation_2.webp";
import yoProduct      from "../../../../../Assets/Images/gallary/branding/yoProduct Manual.webp";
import yoScreen      from "../../../../../Assets/Images/gallary/branding/yoScreen.webp";
import yospiral      from "../../../../../Assets/Images/gallary/branding/yospiral book.webp";
import yoStandee      from "../../../../../Assets/Images/gallary/branding/yoStandee.webp";
import bdyobykes01      from "../../../../../Assets/Images/gallary/branding/bdyobykes01.webp";
import bdyobykes02      from "../../../../../Assets/Images/gallary/branding/bdyobykes02.webp";
import bdyobykes03      from "../../../../../Assets/Images/gallary/branding/bdyobykes03.webp";
import DoDeslect01      from "../../../../../Assets/Images/gallary/branding/DoSelect01.webp";
import DoDeslect02      from "../../../../../Assets/Images/gallary/branding/DoSelect02.webp";
import DoDeslect03      from "../../../../../Assets/Images/gallary/branding/DoSelect03.webp";
import DoDeslect04      from "../../../../../Assets/Images/gallary/branding/DoSelect04.webp";
import DoDeslect05      from "../../../../../Assets/Images/gallary/branding/DoSelect05.webp";
import DoDeslect06      from "../../../../../Assets/Images/gallary/branding/DoSelect06.webp";
import DoDeslect07      from "../../../../../Assets/Images/gallary/branding/DoSelect07.webp";
import DoDeslect08      from "../../../../../Assets/Images/gallary/branding/DoSelect08.webp";
import DoDeslect09      from "../../../../../Assets/Images/gallary/branding/DoSelect09.webp";
import DoDeslect010      from "../../../../../Assets/Images/gallary/branding/DoSelect10.webp";
import DoDeslect011      from "../../../../../Assets/Images/gallary/branding/DoSelect11.webp";
import DoDeslect015      from "../../../../../Assets/Images/gallary/branding/DoSelect15.webp";
import DoDeslect016      from "../../../../../Assets/Images/gallary/branding/DoSelect16.webp";
import ETTMT01      from "../../../../../Assets/Images/gallary/branding/ETTMT01.webp";
import ETTMT02      from "../../../../../Assets/Images/gallary/branding/ETTMT02.webp";
import ETTMT03      from "../../../../../Assets/Images/gallary/branding/ETTMT03.jpg";
import ETTMT04      from "../../../../../Assets/Images/gallary/branding/ETTMT04.webp";
import ETTMT05      from "../../../../../Assets/Images/gallary/branding/ETTMT05.webp";
import ETTMT06      from "../../../../../Assets/Images/gallary/branding/ETTMT06.webp";
import ETTMT07      from "../../../../../Assets/Images/gallary/branding/ETTMT07.webp";
import ETTMT08      from "../../../../../Assets/Images/gallary/branding/ETTMT08.webp";
import ETTMT09      from "../../../../../Assets/Images/gallary/branding/ETTMT09.webp";
import ETTMT10      from "../../../../../Assets/Images/gallary/branding/ETTMT10.webp";
import ETTMT11      from "../../../../../Assets/Images/gallary/branding/ETTMT11.webp";
import ETTMT12      from "../../../../../Assets/Images/gallary/branding/ETTMT13.webp";
import ETTMT13      from "../../../../../Assets/Images/gallary/branding/ETTMT14.webp";
import ETTMT14      from "../../../../../Assets/Images/gallary/branding/tmtmockup_2.webp";
import ETTMT15      from "../../../../../Assets/Images/gallary/branding/tmtmockup_3.webp";
import ETTMT16      from "../../../../../Assets/Images/gallary/branding/tmtmockup_5.webp";
import ETTMT17      from "../../../../../Assets/Images/gallary/branding/tmtmockup_6.webp";
import ETTMT18      from "../../../../../Assets/Images/gallary/branding/tmtmockup_7.webp";
import floret01      from "../../../../../Assets/Images/gallary/branding/floret01.jpg";
import floret02      from "../../../../../Assets/Images/gallary/branding/floret02.png";
import floret03      from "../../../../../Assets/Images/gallary/branding/floret03.png";
import floret04      from "../../../../../Assets/Images/gallary/branding/floret04.png";
import vasuki01      from "../../../../../Assets/Images/gallary/branding/vasuki01.webp";
import vasuki02      from "../../../../../Assets/Images/gallary/branding/vasuki02.webp";
import vasuki03      from "../../../../../Assets/Images/gallary/branding/vasuki03.webp";
import vasuki04      from "../../../../../Assets/Images/gallary/branding/vasuki04.webp";
import vasuki05      from "../../../../../Assets/Images/gallary/branding/vasuki05.webp";
import vasuki06      from "../../../../../Assets/Images/gallary/branding/vasuki06.webp";
import vasuki07      from "../../../../../Assets/Images/gallary/branding/vasuki07.webp";
import vasuki08      from "../../../../../Assets/Images/gallary/branding/vasuki08.webp";
import vasuki09      from "../../../../../Assets/Images/gallary/branding/vasuki09.webp";
import vasuki10      from "../../../../../Assets/Images/gallary/branding/vasuki10.webp";
import vasuki12      from "../../../../../Assets/Images/gallary/branding/vasuki12.webp";
import vasuki13      from "../../../../../Assets/Images/gallary/branding/vasuki13.webp";
import vasuki14      from "../../../../../Assets/Images/gallary/branding/vasuki14.webp";
import vasuki15      from "../../../../../Assets/Images/gallary/branding/vasuki15.webp";
import vasuki16      from "../../../../../Assets/Images/gallary/branding/vasuki16.webp";
import vasuki17      from "../../../../../Assets/Images/gallary/branding/vasuki17.webp";
import bdpacktime01      from "../../../../../Assets/Images/gallary/branding/bdpacktime01.webp";
import bdpacktime02      from "../../../../../Assets/Images/gallary/branding/bdpacktime02.webp";
import bdpacktime03      from "../../../../../Assets/Images/gallary/branding/bdpacktime03.webp";
import bdpacktime04      from "../../../../../Assets/Images/gallary/branding/bdpacktime04.webp";
import bdpacktime05      from "../../../../../Assets/Images/gallary/branding/bdpacktime05.webp";
import bdpacktime06      from "../../../../../Assets/Images/gallary/branding/bdpacktime06.webp";
import bdpacktime07      from "../../../../../Assets/Images/gallary/branding/bdpacktime07.webp";
import bdpacktime08      from "../../../../../Assets/Images/gallary/branding/bdpacktime08.webp";
import Balaji_exhibit1      from "../../../../../Assets/Images/gallary/branding/exhibition/Balaji exhibit1.webp";
import Balaji_exhibit2      from "../../../../../Assets/Images/gallary/branding/exhibition/Balaji exhibit2.webp";
import Balaji_exhibit3      from "../../../../../Assets/Images/gallary/branding/exhibition/Balaji exhibit3.webp";
import Balaji_exhibit4      from "../../../../../Assets/Images/gallary/branding/exhibition/Balaji exhibit4.webp";
import Balaji_exhibit5      from "../../../../../Assets/Images/gallary/branding/exhibition/Balaji exhibit5.webp";
import Floret_exhibit1      from "../../../../../Assets/Images/gallary/branding/exhibition/Floret Exhibit1.webp";
import Floret_exhibit2      from "../../../../../Assets/Images/gallary/branding/exhibition/Floret Exhibit2.webp";
import Packtime_exhibit1      from "../../../../../Assets/Images/gallary/branding/exhibition/Packtime exhibit1.webp";
import Packtime_exhibit2      from "../../../../../Assets/Images/gallary/branding/exhibition/Packtime exhibit2.webp";
import Packtime_exhibit3      from "../../../../../Assets/Images/gallary/branding/exhibition/Packtime exhibit3.webp";
import Packtime_exhibit4      from "../../../../../Assets/Images/gallary/branding/exhibition/Packtime exhibit4.webp";
import YoBykes_exhibit1      from "../../../../../Assets/Images/gallary/branding/exhibition/YoBykes exhibit1.webp";
import YoBykes_exhibit2      from "../../../../../Assets/Images/gallary/branding/exhibition/YoBykes exhibit2.webp";
import YoBykes_exhibit3      from "../../../../../Assets/Images/gallary/branding/exhibition/YoBykes exhibit3.webp";
import YoBykes_exhibit4      from "../../../../../Assets/Images/gallary/branding/exhibition/YoBykes exhibit4.webp";
import YoBykes_exhibit5      from "../../../../../Assets/Images/gallary/branding/exhibition/YoBykes exhibit5.webp";
import ddestationary      from "../../../../../Assets/Images/gallary/branding/ddestationary.webp";
import DDEBrochure      from "../../../../../Assets/Images/gallary/branding/DDEBrochure.webp";
import DDESM1      from "../../../../../Assets/Images/gallary/branding/DDESM1.webp";
import DDESM2      from "../../../../../Assets/Images/gallary/branding/DDESM2.webp";
import DDDEBrochure2      from "../../../../../Assets/Images/gallary/branding/DDDEBrochure2.webp";
import DDE01      from "../../../../../Assets/Images/gallary/branding/exhibition/DDE01.webp";
import DDE02      from "../../../../../Assets/Images/gallary/branding/exhibition/DDE02.webp";
import DDE03      from "../../../../../Assets/Images/gallary/branding/exhibition/DDE03.webp";
import DDE04      from "../../../../../Assets/Images/gallary/branding/exhibition/DDE04.webp";
import DDE05      from "../../../../../Assets/Images/gallary/branding/exhibition/DDE05.webp";




const ALL_SLIDES_BD = [
  { left: [ddestationary, DDEBrochure, DDESM1, DDESM2, DDDEBrochure2],                          behind: [], thumb: ddestationary,      industry: "Manufaturing", sub: "Branding" },
  { left: [yobyke1, yobykehoarding, yobykemain, yoHording_02, yoScreen, yoStandee], behind: [], thumb: yoHording_02, industry: "Automobile",   sub: "Product Branding" },
    { left: [yoFlyer, yobykecalender, yoMango, yonewspaper, yonotepad, yopresentation_1, yopresentation_2, yoProduct, yospiral, flyeryobykes,bdyobykes01, bdyobykes02, bdyobykes03], behind: [], thumb: yopresentation_1, industry: "Automobile",   sub: "Product Branding" },
  
   { left: [Quench02, Quench01, Quench03, Quench04, Quench05, Quench06],                          behind: [], thumb: Quench01,      industry: "Manufaturing", sub: "Product Brochure" },
  { left: [DoDeslect01, DoDeslect02, DoDeslect03, DoDeslect04, DoDeslect05, DoDeslect06],                          behind: [], thumb: DoDeslect01,      industry: "IT Tech", sub: "Product Branding" },
    { left: [DoDeslect011, DoDeslect015, DoDeslect016],                          behind: [], thumb: DoDeslect011,      industry: "IT Tech", sub: "Product Branding" },
    { left: [DoDeslect07, DoDeslect08, DoDeslect09, DoDeslect010,],                          behind: [], thumb: DoDeslect08,      industry: "IT Tech", sub: "Product Branding" },
  { left: [ETTMT01, ETTMT10, ETTMT02, ETTMT03, ETTMT04, ETTMT05, ETTMT06, ETTMT07, ETTMT08, ETTMT09, ETTMT11, ETTMT12, ETTMT13,ETTMT18, ETTMT15, ETTMT17, ETTMT14, ETTMT16],                  behind: [], thumb: ETindoor,      industry: "Manufaturing", sub: "Product Branding" },
  { left: [Business_card, floret01, floret02, floret03, floret04],                   behind: [], thumb: Business_card, industry: "Horticulture", sub: "Product Branding" },
  { left: [kbl01, kbl02, kbl03, kbl04, kbl05, kbl06, kbl07],                                   behind: [], thumb: kbl01,         industry: "Manufaturing", sub: "Product Brochure" },
  { left: [forbes01, forbes02, forbes03],                          behind: [], thumb: forbes01,      industry: "Manufaturing", sub: "Product Brochure" },
  { left: [vasuki01, vasuki02, vasuki03, vasuki04, vasuki05, vasuki06, vasuki07, vasuki08, vasuki09, vasuki10, vasuki12, vasuki13, vasuki14, vasuki15, vasuki16, vasuki17],                          behind: [], thumb: vasuki01,      industry: "Manufaturing", sub: "Product Branding" },
  // { left: [naukribrochure01, naukribrochure02],                          behind: [], thumb: naukribrochure02,      industry: "IT Tech", sub: "Product Brochure" },
  { left: [balaji01, balaji02, balaji03],                          behind: [], thumb: balaji01,      industry: "Horticulture", sub: "Product Branding" },
  //  { left: [flyeryobykes, ], behind: [], thumb: flyeryobykes, industry: "Automobile",   sub: "Product Branding" },
   { left: [bdpacktime01, bdpacktime02, bdpacktime03 ,bdpacktime04, bdpacktime05, bdpacktime06,bdpacktime07, bdpacktime08],                          behind: [], thumb: bdpacktime01,      industry: "Healthcare", sub: "Product Branding" },
  { left: [recoupbrochure07, recoupbrochure08, recoupbrochure09, recoupbrochure10, recoupbrochure01, recoupbrochure02, recoupbrochure03, recoupbrochure04, recoupbrochure05, recoupbrochure06,Recoup01,Recoup02], 
                             behind: [], thumb: recoupbrochure03,      industry: "Healthcare", sub: "Product Branding" },
  { left: [DDE01, DDE02, DDE03, DDE04, DDE05],                          behind: [], thumb: DDE01,      industry: "Exhibition", sub: "Product Branding" },
 { left: [Balaji_exhibit1, Balaji_exhibit2, Balaji_exhibit3, Balaji_exhibit4, Balaji_exhibit5],                          behind: [], thumb: Balaji_exhibit1,      industry: "Exhibition", sub: "Product Branding" },
 { left: [Floret_exhibit1, Floret_exhibit2],                          behind: [], thumb: Floret_exhibit1,      industry: "Exhibition", sub: "Product Branding" },
{ left: [Packtime_exhibit1, Packtime_exhibit2, Packtime_exhibit3, Packtime_exhibit4],                          behind: [], thumb: Packtime_exhibit1,      industry: "Exhibition", sub: "Product Branding" },
{ left: [YoBykes_exhibit1, YoBykes_exhibit2, YoBykes_exhibit3, YoBykes_exhibit4, YoBykes_exhibit5],                          behind: [], thumb: YoBykes_exhibit1,      industry: "Exhibition", sub: "Product Branding" },

];

const INDUSTRIES_BD = ["Manufaturing", "Healthcare", "Automobile", "Horticulture", "IT Tech", "Exhibition"];

/* ── Helpers ── */
const BD_IMAGE_EXTS = [".png", ".jpg", ".jpeg", ".webp", ".gif", ".avif", ".svg"];

function isImageSrcBD(src) {
  if (!src) return false;
  return BD_IMAGE_EXTS.some((ext) => src.toLowerCase().endsWith(ext));
}

/* ══════════════════════════════════════════════
   VIDEO / IMAGE PLAYER  (prefix: bd-)
══════════════════════════════════════════════ */
function VideoPlayerBD({ src, thumb, videoRef: externalRef }) {
  const internalRef = useRef(null);
  const videoRef    = externalRef ?? internalRef;
  const progressRef = useRef(null);
  const wrapRef     = useRef(null);
  const hideTimer   = useRef(null);

  const [playing,   setPlaying]   = useState(false);
  const [progress,  setProgress]  = useState(0);
  const [duration,  setDuration]  = useState(0);
  const [showCtrl,  setShowCtrl]  = useState(false);
  const [isFS,      setIsFS]      = useState(false);
  const [showThumb, setShowThumb] = useState(true);
  const [muted,     setMuted]     = useState(true);
  const [volume,    setVolume]    = useState(1);

  const isImage = isImageSrcBD(src);

  useEffect(() => {
    setShowThumb(true);
    setPlaying(false);
    setProgress(0);
    setDuration(0);
  }, [src]);

  useEffect(() => () => clearTimeout(hideTimer.current), []);

  useEffect(() => {
    const onChange = () => setIsFS(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", onChange);
    return () => document.removeEventListener("fullscreenchange", onChange);
  }, []);

  const fmt = (s) => {
    if (!s || isNaN(s)) return "0:00";
    return `${Math.floor(s / 60)}:${Math.floor(s % 60).toString().padStart(2, "0")}`;
  };

  const togglePlay = (e) => {
    e.stopPropagation();
    if (isImage) return;
    const v = videoRef.current; if (!v) return;
    v.paused ? v.play().catch(() => {}) : v.pause();
  };

  const toggleMute = (e) => {
    e.stopPropagation();
    setMuted((prev) => {
      if (videoRef.current) videoRef.current.muted = !prev;
      return !prev;
    });
  };

  const handleVolume = (e) => {
    e.stopPropagation();
    const val = parseFloat(e.target.value);
    setVolume(val);
    if (videoRef.current) {
      videoRef.current.volume = val;
      videoRef.current.muted  = val === 0;
    }
    setMuted(val === 0);
  };

  const toggleFS = (e) => {
    e.stopPropagation();
    if (!document.fullscreenElement) wrapRef.current?.requestFullscreen().catch(() => {});
    else document.exitFullscreen();
  };

  const handleSeek = (e) => {
    e.stopPropagation();
    if (isImage) return;
    const bar = progressRef.current; const v = videoRef.current;
    if (!bar || !v) return;
    const rect = bar.getBoundingClientRect();
    v.currentTime = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width)) * v.duration;
  };

  const showControls = () => {
    setShowCtrl(true);
    clearTimeout(hideTimer.current);
    hideTimer.current = setTimeout(() => setShowCtrl(false), 2500);
  };

  const effectiveVolume = muted ? 0 : volume;

  const VolumeIcon = () => {
    if (muted || effectiveVolume === 0) return (
      <svg viewBox="0 0 24 24" fill="white" width="20" height="20">
        <path d="M16.5 12A4.5 4.5 0 0 0 14 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06A8.99 8.99 0 0 0 17.73 18l2 2L21 18.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
      </svg>
    );
    if (effectiveVolume < 0.5) return (
      <svg viewBox="0 0 24 24" fill="white" width="20" height="20">
        <path d="M18.5 12A4.5 4.5 0 0 0 16 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z"/>
      </svg>
    );
    return (
      <svg viewBox="0 0 24 24" fill="white" width="20" height="20">
        <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
      </svg>
    );
  };

  /* Image mode */
  if (isImage) {
    return (
      <div ref={wrapRef} className="bd-cvid">
        <img src={src} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block", background: "#000" }} />
      </div>
    );
  }

  /* Video mode */
  return (
    <div
      ref={wrapRef}
      className="bd-cvid"
      onMouseMove={showControls}
      onMouseEnter={showControls}
      onMouseLeave={() => { clearTimeout(hideTimer.current); setShowCtrl(false); }}
      onClick={togglePlay}
    >
      <video
        ref={videoRef}
        src={src}
        muted={muted}
        playsInline
        loop={false}
        onTimeUpdate={() => { const v = videoRef.current; if (v?.duration) setProgress(v.currentTime / v.duration); }}
        onLoadedMetadata={() => { if (videoRef.current) setDuration(videoRef.current.duration); }}
        onPlay={() => { setPlaying(true); setShowThumb(false); }}
        onPause={() => setPlaying(false)}
        onEnded={() => { setPlaying(false); setProgress(0); }}
        style={{ width: "100%", height: "100%", objectFit: isFS ? "contain" : "fill", display: "block", background: "#000" }}
      />

      {thumb && (
        <div className={`bd-cvid-thumb-overlay${showThumb ? " bd-cvid-thumb-overlay--visible" : ""}`}>
          <img src={thumb} alt="" />
        </div>
      )}

      {!playing && (
        <div className="bd-cvid-play-overlay" onClick={togglePlay}>
          <svg viewBox="0 0 80 80" fill="none" width="52" height="52">
            <circle cx="40" cy="40" r="40" fill="rgba(0,0,0,0.45)" />
            <polygon points="32,24 60,40 32,56" fill="white" />
          </svg>
        </div>
      )}

      <div className={`bd-cvid-ctrl${showCtrl ? " bd-cvid-ctrl--show" : ""}`}>

        {/* Play / Pause */}
        <button className="bd-cvid-playbtn" onClick={togglePlay}>
          {playing
            ? <svg viewBox="0 0 24 24" fill="white" width="22" height="22"><rect x="5" y="3" width="4" height="18" rx="1"/><rect x="15" y="3" width="4" height="18" rx="1"/></svg>
            : <svg viewBox="0 0 24 24" fill="white" width="22" height="22"><polygon points="5,3 19,12 5,21"/></svg>
          }
        </button>

        {/* Timestamp */}
        <span className="bd-cvid-time">{fmt(progress * duration)}</span>

        {/* Seek bar */}
        <div ref={progressRef} className="bd-cvid-bar" onClick={handleSeek}>
          <div className="bd-cvid-bar-fill" style={{ width: `${progress * 100}%` }} />
          <div className="bd-cvid-bar-thumb" style={{ left: `${progress * 100}%` }} />
        </div>

        {/* Duration */}
        <span className="bd-cvid-time">{fmt(duration)}</span>

        {/* Volume group */}
        <div className="bd-cvid-vol-group" onClick={(e) => e.stopPropagation()}>
          <button className="bd-cvid-playbtn" onClick={toggleMute} aria-label={muted ? "Unmute" : "Mute"}>
            <VolumeIcon />
          </button>
          <input
            className="bd-cvid-vol-slider"
            style={{ "--vol": effectiveVolume }}
            type="range"
            min="0" max="1" step="0.02"
            value={effectiveVolume}
            onChange={handleVolume}
            aria-label="Volume"
          />
        </div>

        {/* Fullscreen */}
        <button className="bd-cvid-playbtn" onClick={toggleFS}>
          {isFS
            ? <svg viewBox="0 0 24 24" fill="white" width="20" height="20"><path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/></svg>
            : <svg viewBox="0 0 24 24" fill="white" width="20" height="20"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>
          }
        </button>

      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════
   INNER SLIDER — arrow nav within a panel's array
   Auto-slides every 2 s; pauses on hover
══════════════════════════════════════════════ */
function InnerSliderBD({ srcs, thumb, videoRef }) {
  const [idx, setIdx]   = useState(0);
  const hoveredRef      = useRef(false);
  const timerRef        = useRef(null);

  /* Reset to first slide whenever the source list changes */
  useEffect(() => { setIdx(0); }, [srcs]);

  const count = srcs.length;
  const prev  = (e) => { e.stopPropagation(); setIdx((i) => (i - 1 + count) % count); };
  const next  = (e) => { e.stopPropagation(); setIdx((i) => (i + 1) % count); };

  /* Auto-slide: tick every 2 s, skip tick while hovered */
  useEffect(() => {
    if (count <= 1) return;
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      if (!hoveredRef.current) {
        setIdx((i) => (i + 1) % count);
      }
    }, 2000);
    return () => clearInterval(timerRef.current);
  }, [count]);

  const handleMouseEnter = () => { hoveredRef.current = true; };
  const handleMouseLeave = () => { hoveredRef.current = false; };

  if (count === 0) return null;

  return (
    <div
      className="bd-inner-slider"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {srcs.map((src, i) => (
        <div key={i} className={`bd-inner-layer${i === idx ? " bd-inner-layer--active" : ""}`}>
          <VideoPlayerBD
            src={src}
            thumb={i === 0 && !isImageSrcBD(src) ? thumb : undefined}
            videoRef={i === idx ? videoRef : undefined}
          />
        </div>
      ))}

      {count > 1 && (
        <>
          <button className="bd-inner-arrow bd-inner-arrow--prev" onClick={prev} aria-label="Previous">
            <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
              <polyline points="15,6 9,12 15,18" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <button className="bd-inner-arrow bd-inner-arrow--next" onClick={next} aria-label="Next">
            <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
              <polyline points="9,6 15,12 9,18" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <div className="bd-inner-dots">
            {srcs.map((_, i) => (
              <button
                key={i}
                className={`bd-inner-dot${i === idx ? " bd-inner-dot--active" : ""}`}
                onClick={(e) => { e.stopPropagation(); setIdx(i); }}
                aria-label={`Item ${i + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

/* ══════════════════════════════════════════════
   VIDEO SLIDER BRANDING & DESIGN
══════════════════════════════════════════════ */
function VideoSliderBD({ slides }) {
  const [activeSlide, setActiveSlide] = useState(0);
  const [panelIdx,    setPanelIdx]    = useState(0);

  const mainRefs   = useRef([]);
  const behindRefs = useRef([]);
  if (mainRefs.current.length !== slides.length) {
    mainRefs.current   = slides.map((_, i) => mainRefs.current[i]   ?? React.createRef());
    behindRefs.current = slides.map((_, i) => behindRefs.current[i] ?? React.createRef());
  }

  const pauseAll = useCallback((exceptIdx) => {
    slides.forEach((_, i) => {
      if (i === exceptIdx) return;
      [mainRefs.current[i], behindRefs.current[i]].forEach((r) => {
        if (r?.current?.pause) { r.current.pause(); r.current.currentTime = 0; }
      });
    });
  }, [slides]);

  const handleThumbClick = (i) => {
    if (i === activeSlide) return;
    [mainRefs.current[activeSlide], behindRefs.current[activeSlide]].forEach((r) => {
      if (r?.current?.pause) { r.current.pause(); r.current.currentTime = 0; }
    });
    setActiveSlide(i);
    setPanelIdx(0);
    pauseAll(i);
  };

  const currentSlide = slides[activeSlide];
  const leftSrcs   = Array.isArray(currentSlide?.left)   ? currentSlide.left   : (currentSlide?.left   ? [currentSlide.left]   : []);
  const behindSrcs = Array.isArray(currentSlide?.behind) ? currentSlide.behind : (currentSlide?.behind ? [currentSlide.behind] : []);
  const hasBehind  = behindSrcs.length > 0;

  return (
    <div className="bd-vslider-wrap">
      <div className="bd-vslider">

        <div className="bd-vslider-left-wrap">
          <div className="bd-vslider-left">

            {/* Per-slide label — overlay pill, top-left of the panel */}
            {currentSlide?.sub && (
              <div className="bd-sub-pill">{currentSlide.sub}</div>
            )}

            <div className={`bd-vslider-vid-layer${panelIdx === 0 ? " bd-vslider-vid-layer--active" : ""}`}>
              <InnerSliderBD srcs={leftSrcs} thumb={currentSlide?.thumb} videoRef={mainRefs.current[activeSlide]} />
            </div>

            {hasBehind && (
              <div className={`bd-vslider-vid-layer${panelIdx === 1 ? " bd-vslider-vid-layer--active" : ""}`}>
                <InnerSliderBD srcs={behindSrcs} thumb={currentSlide?.thumb} videoRef={behindRefs.current[activeSlide]} />
              </div>
            )}

          </div>

          {hasBehind && (
            <div className="bd-vslider-dots">
              <button className={`bd-vslider-dot${panelIdx === 0 ? " bd-vslider-dot--active" : ""}`} onClick={() => setPanelIdx(0)} aria-label="Main view" />
              <button className={`bd-vslider-dot${panelIdx === 1 ? " bd-vslider-dot--active" : ""}`} onClick={() => setPanelIdx(1)} aria-label="Alternate view" />
            </div>
          )}
        </div>

        <div className="bd-thumb-stack">
          {slides.map((slide, i) => (
            <button
              key={i}
              className={`bd-thumb-stack-item${activeSlide === i ? " bd-thumb-stack-item--active" : ""}`}
              onClick={() => handleThumbClick(i)}
            >
              <img src={slide.thumb} alt={slide.sub} />
            </button>
          ))}
        </div>

      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════
   SECTION BRANDING & DESIGN NEW
══════════════════════════════════════════════ */
export default function SectionBrandingDesignNew() {
  const [activeFilter, setActiveFilter] = useState(null);

  const visibleSlides = useMemo(() => {
    if (!activeFilter) return ALL_SLIDES_BD;
    return ALL_SLIDES_BD.filter((s) => s.industry === activeFilter);
  }, [activeFilter]);

  const handleFilter = (industry) => {
    setActiveFilter((prev) => (prev === industry ? null : industry));
  };

  return (
    <section className="g-section g-section--cream bd-section-decor">
      <div className="g-container">

        <div className="bd-hdr">
          <div className="bd-hdr-left">
            <h2 className="bd-title">Branding &amp; Design</h2>
            <p className="bd-desc">
              Building visual identities and communication systems that
              improve recognition, consistency, and business presentation.
            </p>
          </div>

          <div className="bd-filter-bar">
            {INDUSTRIES_BD.map((ind) => (
              <button
                key={ind}
                className={`bd-filter-btn${activeFilter === ind ? " bd-filter-btn--active" : ""}`}
                onClick={() => handleFilter(ind)}
              >
                {ind}
              </button>
            ))}
            <button
              className={`bd-filter-clear${activeFilter ? " bd-filter-clear--visible" : ""}`}
              onClick={() => setActiveFilter(null)}
              aria-label="Clear filter"
              tabIndex={activeFilter ? 0 : -1}
            >
              <svg viewBox="0 0 24 24" fill="none" width="13" height="13">
                <line x1="4" y1="4" x2="20" y2="20" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
                <line x1="20" y1="4" x2="4"  y2="20" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
              </svg>
            </button>
          </div>
        </div>

        <div className="bd-body">
          {visibleSlides.length > 0 ? (
            <VideoSliderBD
              key={activeFilter ?? "all"}
              slides={visibleSlides}
            />
          ) : (
            <div className="bd-empty">No items found for this industry.</div>
          )}
        </div>

        <p className="bd-bottom-desc">
          Supporting businesses with consistent visual communication across
          products, platforms, and customer touchpoints.
        </p>

      </div>
    </section>
  );
}